<template>
  <span class="LaptopPickButtons">
    <Field
      class="ib"
      icon="laptop"
      :min="minimum"
      type="number"
      :value.sync="countToPick">
      <FieldBtns>
        <Field
          class="xs subfield"
          icon="letter-english-a"
          :value.sync="countAlternatives" />
        <FieldBtn
          class="success"
          :disabled="!canPick"
          @click="$emit('pick', { countMain: countToPick, countAlternatives })">
          {{ $t('pick') }}
        </FieldBtn>
        <FieldBtn
          class="info"
          @click="$emit('clear')">
          {{ $t('clear') }}
        </FieldBtn>
      </FieldBtns>
    </Field>
  </span>
</template>

<script>
export default {
  props: {
    countToPick: { type: Number, required: true },
    minimum: { type: Number, required: true },
  },
  data() {
    return {
      countAlternatives: 1,
    }
  },
  computed: {
    canPick() {
      return this.countToPick >= this.minimum
    },
  },
}
</script>

<style lang="scss">
.LaptopPickButtons {
  > .Field-cont {
    width: 20rem;
  }

  .Field-cont {
    margin: 0;
  }

  .Field-cont.subfield {
    display: inline-block;
    width: 3rem;
  }
}
</style>

<i18n>
{
  "en": {
    "clear": "Clear",
    "pick": "Pick"
  }
}
</i18n>
